import { Box, Grid, Paper, TextField, Tooltip, Typography } from "@mui/material";
import { AttachFile, Edit, Restore as RestoreIcon } from '@mui/icons-material';
import { PermissionWrapper } from "../../../../wrappers";
import { trackActivity } from "../../../../utils/mixpanel";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EngineRightRU from "./EngineRightRU";
import { globalGetService } from "../../../../utils/globalApiServices";
import { checkApiStatus } from "../../../../utils";
import { PageLoader } from "../../../../shared_elements";
import { getEngineRightApi } from "../apiServices";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";
const EngineRightView = () => {
    const params = useParams();
    const [isLoading, setLoading] = useState(false);
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [editEngineRightInfo, setEditEngineRightInfo] = useState({ mode: "", modal: false, data: null })
    const [engineRightInfo, setEngineRightInfo] = useState(null);
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        getEngineRightData();
    }, [])

    const getEngineRightData = (loaderType, query = {}) => {
        setLoading(true);
        globalGetService(getEngineRightApi(params?.leaseSlug)).then(response => {
            if (checkApiStatus(response)) {
                setEngineRightInfo(response?.data?.data);
            }
            setLoading(false);
        })
    }


    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Engine Right`, page_type: page_type, })
    }
    return (
        <>
            <Paper className='card-container headline-readonly-fields' sx={{ p: 1, margin: '10px 1px 8px 1px', backgroundColor: '#FAFAFA', boxShadow: "0px 0px 0px 1px #BBBBBB" }}>
                <Grid sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }} mb={2}>
                    <Typography color="primary" fontSize='18px'> Engine Right</Typography>
                    <Grid>
                        <ul className="list-inline" style={{ float: "right", alignItems: "center", display: "flex" }}>
                            <li>
                                <Tooltip title="Revision History">
                                    <RestoreIcon fontSize="small" className="revision-history" onClick={() => { setRevisionHistory({ modal: true, data: { slug: params?.leaseSlug }, mode: 'view' }); handleItemClicked('Engine Right RevisionHistoryIcon') }} sx={{ cursor: 'pointer' }} color="primary" />
                                </Tooltip>
                            </li>
                            <li>
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "engine_rights", operationType: ['U'] }}>
                                    <Tooltip title="Edit">
                                        <Edit fontSize="small" color="primary" sx={{ cursor: 'pointer' }}
                                            onClick={() => { setEditEngineRightInfo({ modal: true, mode: "edit", data: engineRightInfo }); handleItemClicked('Engine Right EditIcon') }} />
                                    </Tooltip>
                                </PermissionWrapper>
                            </li>
                        </ul>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            id="engine_title_swap_rights"
                            value={engineRightInfo?.lessor_extra_fields?.engine_title_swap_rights || ''}
                            label="Engine Title Swap Rights"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            disabled
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            id="engine_pooling_rights"
                            value={engineRightInfo?.lessor_extra_fields?.engine_pooling_rights || ''}
                            label="Engine Pooling Rights"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            disabled
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            id="engine_swap_lessor_consent"
                            value={engineRightInfo?.lessor_extra_fields?.engine_swap_lessor_consent || ''}
                            label="Engine Swap Lessor Consent Required"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            disabled
                        />
                    </Grid>
                    {!editMode ? <Grid item size={{ md: 12, xs: 12 }}>
                        <LessMoreTextFieldComp label='Remarks' value={engineRightInfo?.lessor_extra_fields?.engine_right_remark} />
                    </Grid> :
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                id="engine_right_remark"
                                value={engineRightInfo?.lessor_extra_fields?.engine_right_remark || ''}
                                label="Remarks"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                fullWidth
                                multiline
                                rows={3}
                                slotProps={{ inputLabel: { shrink: true } }}
                                disabled
                            />
                        </Grid>}
                </Grid>
            </Paper>
            {editEngineRightInfo?.modal ?
                <EngineRightRU
                    editEngineRightInfo={editEngineRightInfo}
                    modeType={editEngineRightInfo?.mode}
                    onOpenAttachments={() => console.log('')}
                    onToggleModal={() => setEditEngineRightInfo({ modal: false, mode: '', data: null })}
                    getResponseBack={() => getEngineRightData()}
                /> : null
            }
             {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"engine_right"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default EngineRightView;